import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from, switchMap, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { GetAllTicketsParams, RecentTicketsResponse } from 'src/app/models/core/recent-ticket.model';

@Injectable({
  providedIn: 'root'
})
export class SoldTicketsApiService {

  private baseUrl = `${environment.api_server}/api/sellers`;

  constructor(private _http: HttpClient, private _api: ApiService) { }

  getAllTickets(params: GetAllTicketsParams): Observable<RecentTicketsResponse> {
    const url = `${this.baseUrl}/dashboard/tickets`;

    let httpParams = new HttpParams();

    if (params.per_page) {
      httpParams = httpParams.set('per_page', params.per_page.toString());
    }

    if (params.titular_name) {
      httpParams = httpParams.set('titular_name', params.titular_name);
    }

    if (params.reference) {
      httpParams = httpParams.set('reference', params.reference);
    }

    if (params.event_id) {
      httpParams = httpParams.set('event_id', params.event_id.toString());
    }

    if (params.product_id) {
      httpParams = httpParams.set('product_id', params.product_id.toString());
    }

    if (params.payment_type) {
      httpParams = httpParams.set('payment_type', params.payment_type);
    }

    if (params.date_from) {
      httpParams = httpParams.set('date_from', params.date_from);
    }

    if (params.date_to) {
      httpParams = httpParams.set('date_to', params.date_to);
    }

    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this._http.get<RecentTicketsResponse>(url, { headers, params: httpParams })
      )
    );
  }
}
